module.exports = __webpack_public_path__ + "static/media/nebulosity.4a03d06c.jpg";